module.exports = __webpack_public_path__ + "img/about-m-slide-15.33752815.jpg";